import { RootState } from '../../redux/store';
import { ScheduleListState } from './ScheduleListState';

export const selectScheduleListState = (state: RootState): ScheduleListState => state.menuBuilder.scheduleList;
